import React, { useState } from 'react';
import { AccountSuccessUiModuleBody } from '../../../../../API';
import Localized from '../../../../shared/Localized';
import UIModuleListItem, { IBaseUIModuleListItemProps } from '../../UIModuleListItem';
import Button from '../../../../shared/Button';
import { useLocales, useTheme } from '../../../../../hooks';
import { StayPrimaryPortrait } from '@mui/icons-material';
import { AccountSuccessPreview } from '../../ContentPreview/AccountSuccessPreview';
import { accountSuccessListItemTestIds } from '../../../../shared/TestsIds';

export type AccountSuccessListItemProps = IBaseUIModuleListItemProps<AccountSuccessUiModuleBody>;

export function AccountSuccessListItem({ uiModule, ...props }: AccountSuccessListItemProps): JSX.Element {
  const { t } = useLocales();
  const { formControlColor } = useTheme();
  const [open, setOpen] = useState(false);

  const onPreviewButtonClick = () => setOpen(true);

  return (
    <>
      <UIModuleListItem
        uiModule={uiModule}
        topLineTitle={<Localized prop={uiModule.title} />}
        collectionLine={[
          <Button
            key="preview"
            variant="text"
            size="small"
            startIcon={<StayPrimaryPortrait />}
            color={formControlColor}
            onClick={onPreviewButtonClick}
            data-testid={accountSuccessListItemTestIds.button}
          >
            {t('layouts.preview_contents')}
          </Button>
        ]}
        {...props}
      />
      <AccountSuccessPreview module={uiModule} open={open} setOpen={setOpen} />
    </>
  );
}
